export var Colors;
(function (Colors) {
    Colors["BLACK"] = "#000000";
    Colors["GRAY_DARK_30"] = "#383838";
    Colors["GRAY_DARK_25"] = "#4E4E4E";
    Colors["GRAY_DARK_20"] = "#5C5C5C";
    Colors["GRAY_DARK_15"] = "#767676";
    Colors["GRAY_DARK_10"] = "#959595";
    Colors["GRAY"] = "#B8B8B8";
    Colors["GRAY_LITE_05"] = "#CACACA";
    Colors["GRAY_LITE_10"] = "#D8D8D8";
    Colors["GRAY_LITE_15"] = "#E4E4E4";
    Colors["GRAY_LITE_20"] = "#EBEBEC";
    Colors["GRAY_LITE_30"] = "#F7F7F7";
    Colors["WHITE"] = "#FFFFFF";
    Colors["NEUTRAL_50"] = "#F5F5F5";
    Colors["PLUM_DARK_30"] = "#320615";
    Colors["BELL_PEPPER_DARK_30"] = "#4A0007";
    Colors["PUMPKIN_DARK_30"] = "#430E02";
    Colors["JACKFRUIT_DARK_30"] = "#493308";
    Colors["PLUM_DARK_20"] = "#591229";
    Colors["BELL_PEPPER_DARK_20"] = "#6E040F";
    Colors["PUMPKIN_DARK_20"] = "#822410";
    Colors["JACKFRUIT_DARK_20"] = "#996E00";
    Colors["PLUM_DARK_10"] = "#922A4C";
    Colors["BELL_PEPPER_DARK_10"] = "#A40F1E";
    Colors["PUMPKIN_DARK_10"] = "#C84F2D";
    Colors["JACKFRUIT_DARK_10"] = "#E0A715";
    Colors["PLUM"] = "#BC4C71";
    Colors["BELL_PEPPER"] = "#D93A4A";
    Colors["PUMPKIN"] = "#E3603C";
    Colors["JACKFRUIT"] = "#F7C647";
    Colors["PLUM_LITE_10"] = "#F08FAF";
    Colors["BELL_PEPPER_LITE_10"] = "#FA6B7A";
    Colors["PUMPKIN_LITE_10"] = "#FA8C6E";
    Colors["JACKFRUIT_LITE_10"] = "#FFE195";
    Colors["PLUM_LITE_20"] = "#FFD0E0";
    Colors["BELL_PEPPER_LITE_20"] = "#FFB4BB";
    Colors["PUMPKIN_LITE_20"] = "#FFCFC2";
    Colors["JACKFRUIT_LITE_20"] = "#FFF4D7";
    Colors["PLUM_LITE_30"] = "#FFECF2";
    Colors["BELL_PEPPER_LITE_30"] = "#FFEAEC";
    Colors["PUMPKIN_LITE_30"] = "#FFEAE4";
    Colors["JACKFRUIT_LITE_30"] = "#FFFAEC";
    Colors["CHIVES_DARK_20"] = "#054808";
    Colors["KALE_DARK_30"] = "#153C32";
    Colors["ELDERBERRY_DARK_30"] = "#072A48";
    Colors["AQUA_DARK_30"] = "#320615";
    Colors["CHIVES_DARK_10"] = "#0B6510";
    Colors["KALE_DARK_20"] = "#246454";
    Colors["ELDERBERRY_DARK_20"] = "#133A5B";
    Colors["AQUA_DARK_20"] = "#003483";
    Colors["CHIVES"] = "#1F8925";
    Colors["KALE_DARK_10"] = "#1B866A";
    Colors["ELDERBERRY_DARK_10"] = "#345C7E";
    Colors["AQUA_DARK_10"] = "#004FC6";
    Colors["CHIVES_LITE_10"] = "#48BB4F";
    Colors["KALE"] = "#27B08D";
    Colors["ELDERBERRY"] = "#4379A7";
    Colors["AQUA"] = "#3174D8";
    Colors["CHIVES_LITE_20"] = "#9AE19E";
    Colors["KALE_LITE_10"] = "#67C9B0";
    Colors["ELDERBERRY_LITE_10"] = "#92B9DA";
    Colors["AQUA_LITE_10"] = "#8BB3EF";
    Colors["CHIVES_LITE_30"] = "#C9FCCC";
    Colors["KALE_LITE_20"] = "#BAF9E9";
    Colors["ELDERBERRY_LITE_20"] = "#D7ECFF";
    Colors["AQUA_LITE_20"] = "#C9DEFF";
    Colors["CHIVES_LITE_40"] = "#E8FFE9";
    Colors["KALE_LITE_30"] = "#E4FFF8";
    Colors["ELDERBERRY_LITE_30"] = "#EDF7FF";
    Colors["AQUA_LITE_30"] = "#E8F1FF";
    Colors["TRANSPARENT"] = "rgba(255, 255, 255, 0)";
    Colors["KOHLRABI_DARK_40"] = "#012B23";
    Colors["KOHLRABI_DARK_30"] = "#003D32";
    Colors["KOHLRABI_DARK_20"] = "#015F4E";
    Colors["KOHLRABI_DARK_10"] = "#0C8973";
    Colors["KOHLRABI"] = "#00AF90";
    Colors["KOHLRABI_LITE_10"] = "#83DCC3";
    Colors["KOHLRABI_LITE_20"] = "#ACEEDB";
    Colors["KOHLRABI_LITE_30"] = "#E5F7F4";
    Colors["KOHLRABI_LITE_40"] = "#F2FDFB";
    Colors["RADISH_DARK_20"] = "#821125";
    Colors["RADISH_DARK_10"] = "#BB1E3A";
    Colors["RADISH"] = "#EC2044";
    Colors["RADISH_LITE_10"] = "#FDE9EC";
    Colors["RADISH_LITE_20"] = "#FEF6F8";
    Colors["ADMIN_BRIGHT_WARNING"] = "#FF0016";
    Colors["BEET"] = "#9E1C4C";
    Colors["CURRENT"] = "currentColor";
    Colors["KALE_400"] = "#89CFBB";
    Colors["RASPBERRY"] = "#F01D59";
    Colors["RASPBERRY_HOVER"] = "#BE0036";
    Colors["RASPBERRY_ACTIVE"] = "#9B0024";
    Colors["RICE"] = "#FFF9F2";
    Colors["MILK"] = "#FFFFFF";
    Colors["SOURDOUGH"] = "#FFDBC7";
    Colors["TURMERIC"] = "#FEC27B";
    Colors["EGGPLANT"] = "#35081A";
    Colors["EGGPLANT_100"] = "#F0D8D8";
    Colors["STRAWBERRY_50"] = "#FFEFEF";
    Colors["STRAWBERRY_100"] = "#FCE3E7";
    Colors["STRAWBERRY_200"] = "#FFD0D0";
    Colors["STRAWBERRY_300"] = "#FFB1B1";
    Colors["STRAWBERRY_400"] = "#F49999";
    Colors["STRAWBERRY_500"] = "#E47777";
    Colors["STRAWBERRY_600"] = "#BA5858";
    Colors["CANTELOUPE_100"] = "#FFEFE6";
    Colors["CANTELOUPE_200"] = "#FFDFCD";
    Colors["CANTELOUPE_300"] = "#FFCFB5";
    Colors["CANTELOUPE_400"] = "#FFAF83";
    Colors["CANTELOUPE_500"] = "#DB906B";
    Colors["CANTELOUPE_600"] = "#CC7048";
    Colors["CANTELOUPE_700"] = "#AF4A27";
    Colors["MINT_50"] = "#F3FAE8";
    Colors["MINT_100"] = "#E7F5D0";
    Colors["MINT_200"] = "#DAEFB9";
    Colors["MINT_300"] = "#C2E58A";
    Colors["MINT_400"] = "#92AC68";
    Colors["MINT_500"] = "#729136";
    Colors["MINT_600"] = "#627A26";
    Colors["BUTTER_50"] = "#FFF7E9";
    Colors["BUTTER_100"] = "#FFEFD3";
    Colors["BUTTER_200"] = "#FFE6BD";
    Colors["BUTTER_300"] = "#FFD691";
    Colors["BUTTER_400"] = "#F4BF73";
    Colors["BUTTER_500"] = "#DDA254";
    Colors["BUTTER_600"] = "#C6873C";
})(Colors || (Colors = {}));
//# sourceMappingURL=colors.js.map